import React, { useState, useEffect, useCallback } from 'react';

const OASIS_URL = 'https://oasis.applesandpears.biz';

export default function WorkflowModal() {
  const [open, setOpen] = useState(() => {
    return !sessionStorage.getItem('di-workflow-shown');
  });

  const close = useCallback(() => {
    setOpen(false);
    sessionStorage.setItem('di-workflow-shown', '1');
  }, []);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  // Listen for close AND open messages from Oasis iframes
  useEffect(() => {
    const handler = (e) => {
      if (e.data && e.data.type === 'oasis-modal-closed') {
        close();
      }
      if (e.data && e.data.type === 'oasis-open-workflow') {
        openModal();
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [close, openModal]);

  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, close]);

  if (!open) return null;

  return (
    <div
      onClick={close}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(0,0,0,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '960px',
          maxWidth: '95vw',
          height: '80vh',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
        }}
      >
        <iframe
          src={`${OASIS_URL}?embed_mode=modal`}
          title="Oasis Daily Workflow"
          allow="autoplay; microphone"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </div>
    </div>
  );
}
